import React from 'react'
import logo from '../../logo.png';
import { Link } from 'react-router-dom';
import useSocketStore from '../../store/socket';

export default function Navbar({ logout, user, notifyIconHandler, chatIconHandler, socket }) {


    const hasNewNotification = useSocketStore((state) => state.newNotification)
    const setNewNotification = useSocketStore((state) => state.setNewNotification)
    const hasNewMessage = useSocketStore((state) => state.newMessage)
    const setHasNewMessage = useSocketStore((state) => state.setNewMessage)


    return (
        <>
            <nav className='sticky top-0 z-10 flex justify-between overflow-hidden items-center bg-white xl:px-40 md:px-20 px-6 py-0 h-16 w-full' >
                <Link to="/account/dashboard">
                    <div className="relative w-fit">
                        <img src={logo} alt="logo" className="md:h-8 h-6" />
                        <span className="font-semibold text-3xl absolute -top-2 xl:-right-4 -right-5">&reg;</span>
                    </div>
                </Link>

                <div className="flex justify-end items-center gap-6">
                    <button onClick={() => {
                        chatIconHandler();
                        setHasNewMessage(false);
                    }} className='relative cursor-pointer text-gray-700 hover:text-blue-800 transition delay-200 ease-in-out'>
                        <span className=''>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                <path d="M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 00-1.032-.211 50.89 50.89 0 00-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 002.433 3.984L7.28 21.53A.75.75 0 016 21v-4.03a48.527 48.527 0 01-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979z" />
                                <path d="M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 001.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0015.75 7.5z" />
                            </svg>
                        </span>
                        {hasNewMessage && <span className="flex h-3 w-3 absolute top-0 right-0">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
                        </span>}
                    </button>
                    <button onClick={(e) => {
                        notifyIconHandler();
                        setNewNotification(false);
                    }} className='cursor-pointer relative text-gray-700 hover:text-blue-800 transition delay-200 ease-in-out'>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                <path d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                                <path fillRule="evenodd" d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z" clipRule="evenodd" />
                            </svg>
                        </span>
                        {hasNewNotification && <span className="flex h-3 w-3 absolute top-0 right-0">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-orange-500"></span>
                        </span>}
                    </button>

                    <Link to="/account/profile" className="md:flex border-4 border-blue-600 rounded-full items-center gap-2 xl:w-2/6 justify-end">
                        <img src={user.avatar} className="h-6 w-6 rounded-full" alt="" />
                    </Link>
                </div>
            </nav>
        </>
    )
}
